import { FirmwareFeature } from '../../../../features/firmware/contract'
import { calculateChecksum } from '../../protocols/common'
import { CMD_OHID, OHID_MIX_ORDER, OHID_CMD_WRITE, PROTOCOL_CONFIG } from '../../protocols/cmd'
import { VersionInfo, VersionType, DeviceType } from '../../../../types/firmware'

const MASTER_REPORT_ID = PROTOCOL_CONFIG.master_report_id
const REPORT_ID = PROTOCOL_CONFIG.report_id

export class OHIDFirmware extends FirmwareFeature {
  private ohidBaseMixWord(options: { write: boolean; order: OHID_MIX_ORDER }): ArrayBuffer {
    const buffer = new ArrayBuffer(64 * 4)
    const view = new DataView(buffer)

    const cmd = options.write
      ? OHID_CMD_WRITE(CMD_OHID.ohid_cmd_base_sync)
      : CMD_OHID.ohid_cmd_base_sync
    let offset = 0

    // 写入头部
    view.setUint8(offset++, MASTER_REPORT_ID) // HEAD
    view.setUint8(offset++, 0) // length
    view.setUint8(offset++, cmd) // cmd
    view.setUint8(offset++, 0) // checksum

    // 更新长度
    const dataLength = offset - 4
    view.setUint8(1, dataLength)

    const checksum = calculateChecksum(view, dataLength, 4)

    view.setUint8(3, checksum & 0xff)

    return buffer.slice(0, offset)
  }

  // ========================= 公开接口 =========================

  async getFirmwareVersion(): Promise<VersionInfo[]> {
    const packetInfo = this.ohidBaseMixWord({
      write: false,
      order: OHID_MIX_ORDER.mix_order_query_ver_str,
    })
    const dataView = new DataView(packetInfo)
    //获取 report ID
    const outputReportId = REPORT_ID
    const inputReportId = REPORT_ID
    // 创建输出数据
    const paddedData = new Uint8Array(dataView.buffer, 0, dataView.byteLength)
    const outputData = new Uint8Array(64)
    outputData.set(paddedData, 0)
    const response = await this.device.sendAndReceive(
      outputReportId,
      outputData,
      inputReportId,
      500,
    )
    const responseBytes = new Uint8Array(
      response.data.buffer,
      response.data.byteOffset,
      response.data.byteLength,
    )
    if (responseBytes[2] == 0xff) {
      throw new Error('setDynamicColorEffect setCurrentEffect fail')
    }
    const versionStr = new TextDecoder().decode(responseBytes.slice(33, 38))
    const versionInfo = {
      version: versionStr,
      versionType: VersionType.MasterControl,
      deviceType: DeviceType.Keyboard,
    }
    return [versionInfo]
  }
}
